import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Navigate, Route, Routes } from 'react-router-dom';
import { Nav } from './components/Nav';
import { useAuth } from './lib/auth';
import { Login } from './pages/Login';
import { Verify } from './pages/Verify';
import { TripList } from './pages/TripList';
import { TripPage } from './pages/Trip';
import { InviteAccept } from './pages/InviteAccept';
import { useLang } from './lib/i18n';
export function App() {
    const { user, loading } = useAuth();
    const { T } = useLang();
    if (loading) {
        return (_jsxs("div", { className: "tt-shell", children: [_jsx(Nav, {}), _jsx("div", { className: "tt-load", children: T('載入中…', '加载中…') })] }));
    }
    return (_jsxs("div", { className: "tt-shell", children: [_jsx(Nav, {}), _jsxs(Routes, { children: [_jsx(Route, { path: "/login", element: user ? _jsx(Navigate, { to: "/trips", replace: true }) : _jsx(Login, {}) }), _jsx(Route, { path: "/auth/verify", element: _jsx(Verify, {}) }), _jsx(Route, { path: "/invite/:token", element: _jsx(InviteAccept, {}) }), _jsx(Route, { path: "/trips", element: user ? _jsx(TripList, {}) : _jsx(Navigate, { to: "/login", replace: true }) }), _jsx(Route, { path: "/trips/:tripId/*", element: user ? _jsx(TripPage, {}) : _jsx(Navigate, { to: "/login", replace: true }) }), _jsx(Route, { path: "/", element: _jsx(Navigate, { to: user ? '/trips' : '/login', replace: true }) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] })] }));
}
